export default __webpack_public_path__ + "static/media/blog2.541a32ba.svg";